module.exports = new __parcel__URL__("github.49dc7afd.svg").toString();